import { type FunctionComponent } from 'react';
import { type IconProps } from '../types';
import { IconWrapper } from '../style';

export const CertificateLight: FunctionComponent<IconProps> = ({
  width = '24px',
  height = '24px',
  cursor,
}: IconProps) => (
  <IconWrapper width={width} height={height} cursor={cursor}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 32 38"
      fill="none"
    >
      <path
        d="M22.6992 27.4004C23.4169 27.4004 23.9996 27.9816 24 28.6992C24 29.4172 23.4172 30 22.6992 30H9.30078C8.58281 30 8 29.4172 8 28.6992C8.00042 27.9816 8.58307 27.4004 9.30078 27.4004H22.6992Z"
        fill="#327EA5"
      />
      <path
        d="M22.6992 19.4004C23.4169 19.4004 23.9996 19.9816 24 20.6992C24 21.4172 23.4172 22 22.6992 22H9.30078C8.58281 22 8 21.4172 8 20.6992C8.00042 19.9816 8.58307 19.4004 9.30078 19.4004H22.6992Z"
        fill="#327EA5"
      />
      <path
        d="M20.248 6.72461C20.4124 6.75642 20.5723 6.81854 20.7168 6.91406C20.7886 6.96149 20.8567 7.01691 20.9199 7.08008L24.9199 11.0801C25.4276 11.5878 25.4276 12.4122 24.9199 12.9199C24.4122 13.4276 23.5878 13.4276 23.0801 12.9199L20 9.83984L16.9199 12.9199C16.4122 13.4276 15.5878 13.4276 15.0801 12.9199C14.5724 12.4122 14.5724 11.5878 15.0801 11.0801L19.0801 7.08008C19.334 6.82641 19.6671 6.69911 20 6.69922C20.0832 6.69919 20.1661 6.7088 20.248 6.72461Z"
        fill="#327EA5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.3848 0C29.395 6.13346e-05 30.2493 0.350843 30.9492 1.05078C31.6492 1.75072 31.9999 2.60502 32 3.61523V34.3848C31.9999 35.395 31.6492 36.2493 30.9492 36.9492C30.2493 37.6492 29.395 37.9999 28.3848 38H3.61523C2.60502 37.9999 1.75072 37.6492 1.05078 36.9492C0.350842 36.2493 6.0784e-05 35.395 0 34.3848V3.61523C6.13346e-05 2.60502 0.350843 1.75072 1.05078 1.05078C1.75072 0.350843 2.60502 6.13346e-05 3.61523 0H28.3848ZM3.61523 3C3.46134 3.00007 3.32129 3.0651 3.19336 3.19336C3.0651 3.32129 3.00007 3.46134 3 3.61523V34.3848C3.00007 34.5387 3.0651 34.6787 3.19336 34.8066C3.32129 34.9349 3.46134 34.9999 3.61523 35H28.3848C28.5387 34.9999 28.6787 34.9349 28.8066 34.8066C28.9349 34.6787 28.9999 34.5387 29 34.3848V3.61523C28.9999 3.46134 28.9349 3.32129 28.8066 3.19336C28.6787 3.0651 28.5387 3.00007 28.3848 3H3.61523Z"
        fill="#327EA5"
      />
      <path
        d="M17.3008 12C17.3008 12.718 16.718 13.3008 16 13.3008C15.282 13.3008 14.6992 12.718 14.6992 12V2H17.3008V12Z"
        fill="#327EA5"
      />
      <path
        d="M25.3008 12C25.3008 12.718 24.718 13.3008 24 13.3008C23.282 13.3008 22.6992 12.718 22.6992 12V2H25.3008V12Z"
        fill="#327EA5"
      />
    </svg>
  </IconWrapper>
);

CertificateLight.displayName = 'CertificateLight';
